/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class ViewErrorKey {
  static readonly VALIDATION = 'kit-view/error/validation';
  static readonly COMPONENT_KEY_MISSING = 'kit-view/error/component-key-missing';
  static readonly COMPONENT_PARENT_ALREADY_ASSIGNED = 'kit-view/error/component-parent-already-assigned';
  static readonly COMPONENT_CONTEXT_MISSING = 'kit-view/error/component-context-missing';
  static readonly COMPONENT_CONTEXT_INVALID = 'kit-view/error/component-context-invalid';
  static readonly COMPONENT_CONTEXT_BINDING_INVALID = 'kit-view/error/component-context-binding-invalid';
  static readonly SELECTED_ITEM_INVALID = 'kit-view/error/selected-item-invalid';
  static readonly MULTIPLE_SELECTED_ITEMS_NOT_ALLOWED = 'kit-view/error/multiple-selected-items-not-allowed';
}
